import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
// import { SessionListData } from "../../../../core/data/json/sessionList";
import { TableData } from "../../../../core/data/interface";
import SessionModals from "../sessionModals";
import Table from "../../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import { status } from "../../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../../core/common/commonSelect";
import { useSession } from "../hooks/useSession";
// import TooltipOption from "../../../../core/common/tooltipOption";

const SessionList = () => {
  const routes = all_routes;
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");

  // Update hook usage with pagination params
  const { getSessionState, paginationData } = useSession({
    page: pageNumber,
    size: recordsPerPage,
    search: search,
  });
  const { sessions: data, isLoading, error } = getSessionState();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [selectedSessionId, setSelectedSessionId] = useState<string>("");

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const handleDeleteClick = (id: string) => {
    setSelectedSessionId(id);
  };

  // Add pagination handlers
  const handlePageChange = (page: number, pageSize?: number) => {
    setPageNumber(page);
    if (pageSize) setRecordsPerPage(pageSize);
  };

  const handleSearchChange = (text: string) => {
    setSearch(text);
  };

  const columns = [
    {
      title: "S. No",
      render: (_: any, __: any, index: number) => index + 1,
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Session Name",
      dataIndex: "name",
      sorter: (a: TableData, b: TableData) => a.name.localeCompare(b.name),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      sorter: (a: TableData, b: TableData) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      sorter: (a: TableData, b: TableData) =>
        new Date(a.end_date).getTime() - new Date(b.end_date).getTime(),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text === "active" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: TableData) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    // to={routes.addSession}
                    to={`${routes.editSession.replace(":id", record.id)}`}
                  >
                    <i className="ti ti-edit me-2" />
                    Edit
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    onClick={() => handleDeleteClick(record.id)}
                  >
                    <i className="ti ti-trash me-2" />
                    Delete
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Sessions List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Sessions</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Sessions
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption /> */}

              <div className="mb-2">
                <Link
                  to={routes.addSession}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Session
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Sessions List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Sessions List</h4>
              <div className="d-flex align-items-center flex-wrap">
                {/* <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div> */}
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to={routes.sessionList}
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              {isLoading ? (
                <div className="text-center">Loading sessions...</div>
              ) : error ? (
                <div className="alert alert-danger m-3">
                  Error loading sessions: {error.toString()}
                </div>
              ) : (
                <Table
                  dataSource={data}
                  columns={columns}
                  onSearchChange={handleSearchChange}
                  pagination={{
                    current: pageNumber,
                    pageSize: recordsPerPage,
                    total: paginationData.totalItems || 0,
                    onChange: handlePageChange,
                    pageSizeOptions: ["All", 10, 20, 30],
                  }}
                />
              )}
              {/* /Student List */}
            </div>
          </div>
          {/* /Sessions List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <SessionModals sessionId={selectedSessionId} />
    </>
  );
};

export default SessionList;
